import { render, staticRenderFns } from "./SkyBook.vue?vue&type=template&id=4ad7fc0c&scoped=true&"
var script = {}
import style0 from "./SkyBook.vue?vue&type=style&index=0&id=4ad7fc0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad7fc0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ad7fc0c')) {
      api.createRecord('4ad7fc0c', component.options)
    } else {
      api.reload('4ad7fc0c', component.options)
    }
    module.hot.accept("./SkyBook.vue?vue&type=template&id=4ad7fc0c&scoped=true&", function () {
      api.rerender('4ad7fc0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/SkyBook.vue"
export default component.exports